<template>
  <div>
    <section class="content-header">
      <h1>
        เพิ่มกลุ่มบริษัทของผู้ให้บริการโทรศัพท์เคลื่อนที่
        <small></small>
      </h1>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box">
              <div class="box-header">
                <div class="wrapper_addtypegroup">
                  <el-form
                    size="mini"
                    :label-position="label_position"
                    label-width="150px"
                    class="demo-ruleForm"
                  >
                    <div class="row">
                      <div class="col-md-2"></div>
                      <div class="col-md-8">
                        <el-form size="mini">
                          <el-form-item label="ชื่อกลุ่มบริษัท" required>
                            <el-input
                              placeholder="กรุณากรอกข้อมูล"
                              v-model="company_name"
                              clearable
                            ></el-input>
                          </el-form-item>
                          <el-form-item label="ชื่อรายการบริษัททั้งหมด" required >
                            <el-checkbox-group  v-model="company_list" v-if="this.type == 'broadband' || this.type == 'mobile'">
                              <template v-for="provider in list_mobile">
                                <el-checkbox  :label="provider.info" :key="provider.info" v-if="ungroup_providers.some((item) => { return item.id == provider.info })">{{provider.brand_name}}</el-checkbox>
                                <el-checkbox  :label="provider.info" :key="provider.info" v-else disabled>{{provider.brand_name}}</el-checkbox>
                              </template>
                            </el-checkbox-group>
                            <span v-else>กรุณาเลือกประเภทการให้บริการ</span>
                          </el-form-item>
                          <el-form-item label="โลโก้กลุ่มบริษัท" required>
                            <el-upload
                            style="widht: 700px"
                              class="avatar-uploader"
                              action="#"
                              ref="file"
                              :auto-upload="false"
                              :show-file-list="false"
                              :on-change="onFileChange"
                              accept="image/jpeg,image/png"
                            >
                              <img v-if="url" :src="url" class="avatar" />
                              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                          </el-form-item>
                          <el-form-item label="โค้ดสีกลุ่มบริษัท (ใช้สำหรับรายงาน)" required>
                            <el-input
                              placeholder="กรุณากรอกข้อมูล"
                              v-model="codeColor"
                              type="color"
                              style="width:300px;"
                            ></el-input>
                          </el-form-item>
                        </el-form>
                      </div>
                    </div>
                    <div class="box-footer">
                      <el-button style="float: left" type="secondary" @click="back()">ยกเลิก</el-button>
                      <el-button style="float: right" type="primary" @click="submitForm()">บันทึก</el-button>
                    </div>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      url: "",
      file: null,
      label_position: "top",
      company_list: [],
      company_name: "",
      type: "mobile",
      radio: "1",
      checkboxList: [],
      codeColor: "",
      selectType: [
        {
          value: "mobile",
          label: "โทรศัพท์เคลื่อนที่"
        },
        {
          value: "broadband",
          label: "อินเทอร์เน็ตความเร็วสูงประจำที่"
        }
      ]
    };
  },
  created(){
    this.$store.dispatch('ListOperator/get_ungroup_operator')
    this.allProvider()
  },
  computed: {
    ...mapState({
      store_providers: store => store.ListOperator.operators,
      ungroup_providers: store => store.ListOperator.ungroup_operator
    }),
    ...mapGetters({
      list_mobile: "ListOperator/list_mobile",
      list_broadband: "ListOperator/list_broadband"
    })
  },
  methods: {
      ...mapActions({
      addTypegroup: "Typegroup/addTypegroup",
      allProvider: "ListOperator/fetch_table",
    }),
    changeType(){ 
      this.checkboxList = []
      if(this.type == 'broadband') {
        for(let item of this.list_broadband) {
          this.checkboxList.push(item)
        }
      } else {
        for(let item of this.list_mobile) {
          this.checkboxList.push(item)
        }
      }
    },
    submitForm() {
      if(!this.type)
        this.$confirm("กรุณาเลือกประเภทการให้บริการ", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
          showCancelButton: false,
          type: "warning"
        })
      else if(!this.company_name)
        this.$confirm("กรุณากรอกชื่อกลุ่มบริษัท", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
          showCancelButton: false,
          type: "warning"
        })
      else if(this.company_list.length === 0)
        this.$confirm("กรุณาเลือกรายการบริษัทอย่างน้อย 1 รายการ", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
          showCancelButton: false,
          type: "warning"
        })
      else if(!this.file)
        this.$confirm("กรุณาอัปโหลดโลโก้กลุ่มบริษัท", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
          showCancelButton: false,
          type: "warning"
        })
      else if(!this.codeColor)
        this.$confirm("กรุณาเลือกสี", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
          showCancelButton: false,
          type: "warning"
        })
       else{
          let list_text = JSON.stringify(this.company_list)
          let formData = new FormData();
           formData.append('typeFile', 'logo');
           formData.append('provider_type', this.type);
           formData.append('group_name', this.company_name);
           formData.append('group_company_list',list_text);
           formData.append('group_color_code', this.codeColor);
           formData.append('file', this.file);
         this.addTypegroup(formData)
         this.$router.push({name : 'Typegroup'})
       }
    },
    onFileChange(e) {
      this.$refs.file.clearFiles()
      this.file = e.raw;
      this.url = URL.createObjectURL(this.file);
    },
    back(){
      this.$router.push({name : 'Typegroup'})
    }
  }
};
</script>
<style >
#preview {
  display: flex;
  justify-content: center;
  align-items: center;
}
#preview img {
  max-width: 100%;
  max-height: 100%;
}
</style>

